


import {
  defineComponent,
  PropType,
  onMounted,
  computed,
  reactive,
} from '@vue/composition-api';
import type { StandardReportCar, StandardReport } from '@/models/externalReports/standard/spStandardReport';
import type {
  ExternalReportsLabelSp,
  ExternalReportSettings,
} from '@/models/apis/externalReports/external_report_settings';
import type {
  StandardReportOperationStartTsUpdateParams,
} from '@/models/apis/externalReports/standard/standardReportRequest';
import standardReportApi from '@/apis/externalReports/standard/standard_report';
import useSpeech from '@/composables/useSpeech';
import { useRequestGuard } from '@/composables/useRequestGuard';
import { useRoute } from '@/hooks/useRoute';

interface PreWorkState {
  showConfirmStartWorkingModal: boolean;
  standardReport: StandardReport;
}
export default defineComponent({
  props: {
    standardCar: {
      type: Object as PropType<StandardReportCar>,
      required: true,
    },
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
  },
  emits: [
    'startWorking',
    'editContentAndRoad',
    'showErrorOnCommon',
  ],
  setup(props, { emit }) {
    const state = reactive<PreWorkState>({
      showConfirmStartWorkingModal: false,
      standardReport: props.standardCar.report,
    });
    const { doSpeech } = useSpeech();
    const { router } = useRoute();
    const { doRequest, isRequesting } = useRequestGuard((errorMessage) => {
      emit('showErrorOnCommon', errorMessage);
    });

    const spLabels = computed<ExternalReportsLabelSp>(() => {
      return props.userSettings.sp;
    });

    const startWorking = async() => {
      state.showConfirmStartWorkingModal = false;
      const params: StandardReportOperationStartTsUpdateParams = {
        operation_start_ts: new Date(),
      };
      await doRequest(async() => {
        state.standardReport = await standardReportApi.updateStandardReportStart(state.standardReport.id, params);
      }, '作業開始に失敗しました。再度操作を行ってください。');
      doSpeech(spLabels.value.message.confirm_start_work);
      emit('startWorking', props.userSettings.choices.status.working.key, state.standardReport);
    };
    const editContentAndRoad = () => {
      emit('editContentAndRoad');
    };

    onMounted(() => {
      if (state.standardReport.id === 0) {
        router.push({name: 'Login'});
      }
    });

    return {
      state,
      isRequesting,
      spLabels,
      editContentAndRoad,
      startWorking,
    };
  },
});
